
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL || "";

export interface AddPublicSubnetPayload {
	id: number;
	ip: string;
	mask: string; // e.g. "34"
	status: string; // e.g. "assigned", "available", etc.
	ipBlockId: number;
	ipBlock?: {
		name: string; // from the example: "ipBlock": { "name": "IPX01" }
	};
}

//GET v1/subnet-public
export function getAllPublicSubnets(token: string) {
	return axios.get(`${API_URL}/v1/subnet-public`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}

//POST v1/subnet-public
export function addPublicSubnet(token: string, payload: AddPublicSubnetPayload) {
	return axios.post(`${API_URL}/v1/subnet-public`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//PUT v1/subnet-public/:id
export function editPublicSubnet(token: string, id: number, payload: AddPublicSubnetPayload) {
	const encodedId = encodeURIComponent(id);
	return axios.put(`${API_URL}/v1/subnet-public/${encodedId}`, payload, {
		headers: {
			Authorization: `Bearer ${token}`,
			"Content-Type": "application/json",
		},
	});
}

//DELETE v1/subnet-public
export function deletePublicSubnet(token: string, id: number) {
	const encodedId = encodeURIComponent(id);
	return axios.delete(`${API_URL}/v1/subnet-public/${encodedId}`, {
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});
}